import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {DexWalletWidgetSettings, DexWalletWidgetSettingsDef} from './dex-wallet-widget-settings';

@Injectable()
export class DexWalletWidgetSettingsService implements WidgetSettingsService {

    public getDefaultSettings(): Observable<DexWalletWidgetSettings> {
        const defaultWidgetSettings: DexWalletWidgetSettings = {
            title:   null,
            filters: {
                assetSymbol:           null,
                isOnlySupportedAssets: true
            }
        };

        return of(defaultWidgetSettings);
    }

    public fromDefinition(settingsDef: DexWalletWidgetSettingsDef): Observable<DexWalletWidgetSettings> {
        return of<DexWalletWidgetSettings>({
            title:   settingsDef.title,
            filters: settingsDef.filters ? {...settingsDef.filters} : null
        });
    }

    public toDefinition(settings: DexWalletWidgetSettings): DexWalletWidgetSettingsDef {
        return {
            title:   settings.title,
            filters: settings.filters ? {...settings.filters} : null
        };
    }

}
